import { isEnabled } from "lib/@components/feature"
import { assetFields } from "routes/asset-register/plugins/regime-display/asset-fields.mjs"
import { FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING } from "routes/asset-register/plugins/asset-mapping/feature-flag-mobiliser-advanced-mapping.runtime"

export function isMobiliserAdvancedMappingEnabled() {
    return isEnabled(FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING)
}

export function getRolloutAssetFields(fields = assetFields) {
    if (isMobiliserAdvancedMappingEnabled()) return fields.filter((field) => !field.hiddenByRollout)
    return fields.filter((field) => !field.requiresRollout).map(toLegacyField)
}

function toLegacyField(field) {
    return field.legacyLabel ? { ...field, label: field.legacyLabel } : field
}
